var $eda3511d3b2e0e51$exports = {};
$eda3511d3b2e0e51$exports = {
    "loading": `Carregando...`,
    "loadingMore": `Carregando mais...`
};


export {$eda3511d3b2e0e51$exports as default};
//# sourceMappingURL=pt-BR.module.js.map
